import { action } from 'typesafe-actions'
import { Supplier } from '@models/supplier'
import {RequestData} from "@models/axios";

export const enum  SupplierActionTypes {
    FETCH_REQUEST = '@@supplier/FETCH_REQUEST',
    FETCH_SUCCESS = '@@supplier/FETCH_SUCCESS',
    FETCH_ERROR = '@@supplier/FETCH_ERROR',

    DELETE_REQUEST = '@@supplier/DELETE_REQUEST',
    DELETE_SUCCESS = '@@supplier/DELETE_SUCCESS',
    DELETE_ERROR = '@@supplier/DELETE_ERROR',

    CREATE_REQUEST = '@@supplier/CREATE_REQUEST',
    CREATE_SUCCESS = '@@supplier/CREATE_SUCCESS',
    CREATE_ERROR = '@@supplier/CREATE_ERROR',

    UPDATE_REQUEST = '@@supplier/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@supplier/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@supplier/UPDATE_ERROR',
}

export const fetchRequest = (data:RequestData) => action( SupplierActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Supplier[]) => action( SupplierActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action( SupplierActionTypes.FETCH_ERROR, message);


export const deleteRequest = (data:RequestData) => action( SupplierActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:RequestData) => action( SupplierActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action( SupplierActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action( SupplierActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: Supplier[]) => action( SupplierActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action( SupplierActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action( SupplierActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: Supplier[]) => action( SupplierActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action( SupplierActionTypes.UPDATE_ERROR, message);